import { Grid, styled } from "@mui/material";

export const InnerMarginBox = styled(Grid)`
  > * {
    margin: 0.5em;
  }
`;
